import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {
  BankType,
  PortalType,
  ScreenShotGenerationParamName,
} from '@sparrow-card/sparrow-card-constants';
import { QueryParams } from 'enums/QueryParams';
import { type RootState } from 'stores';

const isBankType = (value: string | null): value is BankType =>
  !!value && (Object.values(BankType) as string[]).includes(value);

const useDmBankPartner = (): BankType | undefined => {
  const [searchParams] = useSearchParams();
  const portalType = useSelector((state: RootState) => state.application.portalType);
  const storedBankPartner = useSelector((state: RootState) => state.application.bankPartner);

  if (portalType !== PortalType.DirectMail) {
    return undefined;
  }

  const isScreenshotGeneration = searchParams.get(ScreenShotGenerationParamName) === 'true';
  const bankPartnerFromQuery = searchParams.get(QueryParams.BankPartner);

  if (isScreenshotGeneration && isBankType(bankPartnerFromQuery)) {
    return bankPartnerFromQuery;
  }

  return storedBankPartner;
};

export default useDmBankPartner;
